import React from 'react'
import { Form } from 'antd';
import { Grid, Snackbar } from '@material-ui/core';
import MySnackbarContentWrapper from "../../../components/SnackBar";
import Inputs from "./inputs";

class BlackListForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };
  
  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  generateInputArray = (urls, reasons) => {
    return urls.map((url, index) => {
      return {
        url,
        reason: reasons[index]
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({ 
          variables: { 
            id: this.props.id, 
            inputs: this.generateInputArray(values.url, values.reason)
          } 
        }).then(result =>{
          this.setStateValues(true,"success","Action executed with success!");
          this.props.form.resetFields();
          if(this.props.onCancel){
            this.props.onCancel();
          }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true,"error","Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true,"error","Form validation failed!");  
      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar 
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} 
          open={this.state.snackOpen} 
          autoHideDuration={6000} 
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper 
            onClose={this.handleClose} 
            variant={this.state.snackType} 
            message={this.state.snackMessage}
          />
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          <Inputs inputs={[{input: {url: '', reason: ''}}]} form={this.props.form} />
        </Grid>
        </Grid>
        </form>
    );
  }
}

const BlackListURLsForm = Form.create()(BlackListForm);

export default BlackListURLsForm